import { render, staticRenderFns } from "./stampsList.vue?vue&type=template&id=cfaf76b6&scoped=true&"
import script from "./stampsList.vue?vue&type=script&lang=js&"
export * from "./stampsList.vue?vue&type=script&lang=js&"
import style0 from "./stampsList.vue?vue&type=style&index=0&id=cfaf76b6&lang=scss&scoped=true&"
import style1 from "./stampsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfaf76b6",
  null
  
)

export default component.exports